module.exports = __webpack_public_path__ + "media/images/icons/dollar-4b94ee6feb5dd400466a407a973b4bb1.svg";